import { ErrorHandler, ModuleWithProviders, NgModule, Provider, Type } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Contacts } from '@ionic-native/contacts/ngx';
import { SuperTabsModule } from '@ionic-super-tabs/angular';
import { IonicModule } from '@ionic/angular';
import { FormlyModule } from '@ngx-formly/core';
import { SharedComponentsModule } from 'apps/idl/src/components/sharedComponents.module';
import { IntegrityModule } from 'apps/idl/src/modules/integrity/integrity.module';
import { OsappModule } from 'apps/idl/osapp.module';
import { NgCalendarModule } from 'ionic2-calendar';
import { IDL_FORMLY_CONFIG_OPTION } from '../model/IdlComponentRegister';
import { IdlPipeModule } from '../pipes/idlPipes.module';
import { ActesModule } from './actes/actes.module';
import { PatientsModule } from './patients/patients.module';
import { TraitementSlideModule } from './traitement/traitement-slide-page.module';

const importModules: Array<Type<any> | ModuleWithProviders<any>> = [
	IonicModule,
	OsappModule,
	NgCalendarModule,
	SharedComponentsModule,
	IdlPipeModule,
	FormlyModule.forChild(IDL_FORMLY_CONFIG_OPTION),
	SuperTabsModule,
	MatSlideToggleModule,
	ActesModule,
	IntegrityModule,
	PatientsModule
];
const exportModules: Type<any>[] = [
	TraitementSlideModule,
	PatientsModule,
];
const components: Type<any>[] = [];
const providers: Provider[] = [
	{ provide: ErrorHandler, useClass: ErrorHandler },
	Contacts
];

@NgModule({
	imports: importModules,
	exports: exportModules,
	declarations: components,
	providers: providers
})
export class CustomModule { }